import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=29621c52&"
import script from "./IconPicker.vue?vue&type=script&lang=js&"
export * from "./IconPicker.vue?vue&type=script&lang=js&"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=29621c52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports